import { getAssetLink } from '@doltech/utils/lib/url';

export const bannerHomePage = {
  imgVertical: {
    src: getAssetLink({
      item: {
        handle: 'pwhG5LjQQxKMkv7vwlN9',
      },
    }),
    width: 1343,
    height: 2877,
  },
  imgHorizontal: {
    src: getAssetLink({
      item: {
        handle: 'h1bhdppdQQuazmNkF0c2',
      },
    }),
    width: 4000,
    height: 1031,
  },
};

export const bannerOnlineTest = {
  imgVertical: {
    src: getAssetLink({
      item: {
        handle: '3i6dHPFgQAqxjznNe0I0',
      },
    }),
    width: 1343,
    height: 2877,
  },
  imgHorizontal: {
    src: getAssetLink({
      item: {
        handle: '7EPpfu0QHSbo4j88CVgI',
      },
    }),
    width: 4000,
    height: 1031,
  },
};

export const bannerSpeakingSample = {
  imgVertical: {
    src: getAssetLink({
      item: {
        handle: '4cwr1hFR8mV8W3xYuWHm',
      },
    }),
    width: 1343,
    height: 2877,
  },
  imgHorizontal: {
    src: getAssetLink({
      item: {
        handle: 'zbh3s9xRxqJjvjbXAQMA',
      },
    }),
    width: 4000,
    height: 1031,
  },
};

export const bannerWritingSample = {
  imgVertical: {
    src: getAssetLink({
      item: {
        handle: '4cwr1hFR8mV8W3xYuWHm',
      },
    }),
    width: 1343,
    height: 2877,
  },
  imgHorizontal: {
    src: getAssetLink({
      item: {
        handle: 'zbh3s9xRxqJjvjbXAQMA',
      },
    }),
    width: 4000,
    height: 1031,
  },
};
